import { MealWithIntakes } from "../data/plan";
import { MealWithIngredients } from "../data/mealWithIngredients";
import { StepModification } from "../data/dishModification";
import { Intake } from "../data/intake";
import { PurchaseDto } from "../api";

type MealLike = MealWithIntakes | MealWithIngredients;

/** Sammelt alle FoodUnit-Ids, die in Dish-Steps referenziert werden. */
export function collectFoodUnitIds(steps: StepModification[]): number[] {
  const ids = new Set<number>();
  steps.forEach((step) =>
    step.ingredients.forEach((ingredient) => {
      if (ingredient.foodUnitId) ids.add(ingredient.foodUnitId);
      ingredient.alternatives?.forEach((alt) => {
        if (alt.foodUnitId) ids.add(alt.foodUnitId);
      });
      ingredient.personChoices?.forEach((choice) => {
        if (choice.foodUnitId) ids.add(choice.foodUnitId);
      });
    }),
  );
  return [...ids];
}

/**
 * Sammelt alle Food-Ids, die in Meal-Ingredients referenziert werden –
 * food-basiert über `foodUnitFoodId`, purchase-basiert über den Purchase.
 */
export function collectFoodIds(
  meals: MealLike[],
  purchases: PurchaseDto[] = [],
): number[] {
  const ids = new Set<number>();
  meals.forEach((meal) => {
    const ingredients =
      "mealIngredients" in meal
        ? meal.mealIngredients
        : meal.meal.mealIngredients;
    ingredients.forEach((ingredient) => {
      if (ingredient.foodUnitFoodId && ingredient.foodUnitFoodId > 0) {
        ids.add(ingredient.foodUnitFoodId);
      } else if (ingredient.purchaseUnitPurchaseId) {
        const foodId = purchases.find(
          (purchase) => purchase.id === ingredient.purchaseUnitPurchaseId,
        )?.foodId;
        if (foodId && foodId > 0) ids.add(foodId);
      }
    });
  });
  return [...ids];
}

/**
 * Sammelt alle Purchase-Ids, die in Meal-Ingredients referenziert werden.
 */
export function collectPurchaseIds(meals: MealLike[]): number[] {
  const ids = new Set<number>();
  meals.forEach((meal) => {
    const ingredients =
      "mealIngredients" in meal
        ? meal.mealIngredients
        : meal.meal.mealIngredients;
    ingredients.forEach((ingredient) => {
      if (
        ingredient.purchaseUnitPurchaseId &&
        ingredient.purchaseUnitPurchaseId > 0
      ) {
        ids.add(ingredient.purchaseUnitPurchaseId);
      }
    });
  });
  return [...ids];
}

/** Sammelt die Purchase-Ids aus Intakes. */
export function collectPurchaseIdsFromIntakes(intakes: Intake[]): number[] {
  const ids = new Set<number>();
  intakes.forEach((intake) => {
    if (
      intake.purchaseUnitPurchaseId &&
      intake.purchaseUnitPurchaseId > 0
    ) {
      ids.add(intake.purchaseUnitPurchaseId);
    }
  });
  return [...ids];
}
